module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dash-cont"
  }, [_c('h1', {
    staticClass: "white text"
  }), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "ui inverted small statistics",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "red inverted statistic"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("unchecked")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('i', {
    staticClass: "exclamation icon"
  }), _vm._v(" " + _vm._s(_vm.stats.alerts) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n       Alerts\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "orange inverted statistic"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("unchecked")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('i', {
    staticClass: "exclamation icon"
  }), _vm._v(" " + _vm._s(_vm.stats.warnings) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n      Warnings\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "purple inverted statistic"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("in")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n      " + _vm._s(_vm.stats.productsWithIssues) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n      Products\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "green inverted statistic"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Of")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n      " + _vm._s(_vm.stats.totalProducts) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n      total\n    ")])])]), _vm._v(" "), (_vm.$root.authCompleted && _vm.$parent.$parent.onboarding.syncing && _vm.$root.secondsSinceFirstSellerAccountCreated < 9999) ? _c('div', {
    staticClass: "ui icon message",
    staticStyle: {
      "text-shadow": "none"
    },
    attrs: {
      "data-onboarding": "syncing"
    }
  }, [_c('i', {
    staticClass: "notched circle loading icon"
  }), _vm._v(" "), _c('i', {
    staticClass: "close icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$parent.$parent.onboarder('syncing')
      }
    }
  }), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.emailConfirmReminder.length > 0) ? _c('div', {
    staticClass: "ui icon message",
    staticStyle: {
      "text-shadow": "none"
    }
  }, [_c('i', {
    staticClass: "mail outline icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("Check your inbox and confirm\n      "), _vm._l((_vm.emailConfirmReminder), function(email, index) {
    return _c('strong', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index > 0),
        expression: "index>0"
      }]
    }, [_vm._v(",")]), _vm._v(" " + _vm._s(email))])
  }), _vm._v(".\n      "), _c('br'), _vm._v(" "), _c('small', [_vm._v("It is also a good idea to whilelist @SentryKit.com e-mail addresses.")])], 2)])]) : _vm._e(), _vm._v(" "), (_vm.$root.paymentStatus == 402) ? _c('div', {
    staticClass: "ui negative message",
    staticStyle: {
      "text-shadow": "none"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n    Your SentryKit account is unfortunately suspended.\n  ")]), _vm._v(" "), _c('p', [_vm._v("We really tried but couldn't charge you for the current running month.")]), _vm._v(" "), _c('p', [_vm._v("Please add a payment method in your "), _c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" and get in touch with Support to continue using the service.")], 1)]) : _vm._e(), _vm._v(" "), (_vm.$root.paymentStatus == 99402) ? _c('div', {
    staticClass: "ui negative message",
    staticStyle: {
      "text-shadow": "none"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n    Your SentryKit account is currently suspended.\n  ")]), _vm._v(" "), _c('p', [_vm._v("Sorry, but after multiple attempts we still couldn't charge you for the current month.")]), _vm._v(" "), _c('p', [_vm._v("Please add a payment method in your "), _c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" then get in touch with Support to continue using the service.")], 1)]) : _vm._e(), _vm._v(" "), (_vm.$root.paymentStatus == 403) ? _c('div', {
    staticClass: "ui negative message",
    staticStyle: {
      "text-shadow": "none"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n    Your SentryKit account is currently suspended.\n  ")]), _vm._v(" "), _c('p', [_vm._v("Sorry, it seems your payment plan has been cancelled.")]), _vm._v(" "), _c('p', [_vm._v("Please add a payment method in your "), _c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" then get in touch with Support to continue using the service.")], 1)]) : _vm._e(), _vm._v(" "), (_vm.$root.paymentStatus == 3) ? _c('div', {
    staticClass: "ui negative message",
    staticStyle: {
      "text-shadow": "none"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n    Payment Failed\n  ")]), _vm._v(" "), _c('p', [_vm._v("Your payment for this running month of your SentryKit subscription failed.")]), _vm._v(" "), _c('p', [_vm._v("No worries, we get it that this can happen. We left everything running for you but you are now running on credit.")]), _vm._v(" "), _c('p', [_vm._v("Please add or change the payment method in your "), _c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" to continue using the service distruption free.")], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n      Hi there and welcome! Things are still syncing up, but you can already get started.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      In a few hours all modules will be fully on-line.\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-777b9415!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = 794
// module chunks = 2